var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.Chart,{tag:"component",attrs:{"chartData":_vm.data,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }